import React from "react";
import "react-data-table-component-extensions/dist/index.css";
import { Button, Card, Col } from "react-bootstrap";
import { ColorCodeTable } from "../allTables/allTable";
import { useEffect } from "react";
import { useState } from "react";
import * as yup from "yup";
import { AddColorCode, DeleteColorCode } from "../modals/allModal";
import { useFormik } from "formik";
import { enqueueSnackbar } from "notistack";
import ColorCodeService from "../../services/coloeCode.service";
import { useLocation } from "react-router-dom";

const contactSchema = yup.object().shape({
  colorCode: yup.mixed().required("Color Code is required"),
  playerName: yup.string().required("Player Name is required"),
  textColorCode: yup.mixed().required("Text Color Code is required"),
});

const schema = yup.object().shape({
  colorCodeDetail: yup.array().of(contactSchema),
  seasonName: yup.string().required("Season Name is required"),
});

export function ColorCode() {
  const location = useLocation();
  const { search } = location;
  const selectedType = search.split("=")[1];
  const [data, setData] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [deleteModal, setDeleteModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [addNumbers, setAddNumbers] = useState(1);
  const [loader, setLoader] = useState(false);
  const [totalRows, setTotalRows] = useState("");
  const [color, setColor] = useState("");
  const [colorPickerOpen, setColorPickerOpen] = useState(Array(addNumbers));
  const [showPicker, setShowPicker] = useState(false);
  const [color2, setColor2] = useState("");
  const [colorPickerOpen2, setColorPickerOpen2] = useState(Array(addNumbers));
  const [showPicker2, setShowPicker2] = useState(false);
  const [tempColor2, setTempColor2] = useState(color);
  const [tempColor, setTempColor] = useState(color);
  const [update, setUpdate] = useState(false);
  const handleDialogClose = () => setModalShow(false);
  const handleDeleteClose = () => setDeleteModal(false);

  const getAllData = async () => {
    setIsLoading(true);
    try {
      const response = await ColorCodeService.GetAllColorCode(
        pageNumber,
        dataPerPage,
        selectedType.toUpperCase()
      );
      setData(response.data.data);
      setTotalRows(response.data.totalCount);
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePerPageChange = async (newPerPage, newPageNumber) => {
    setIsLoading(true);
    setDataPerPage(newPerPage);
    setPageNumber(newPageNumber);
    await getAllData();
    setIsLoading(false);
  };

  const handlePageChange = async (newPageNumber) => {
    setIsLoading(true);
    setPageNumber(newPageNumber);
    setIsLoading(false);
  };

  useEffect(() => {
    getAllData();
  }, [pageNumber, dataPerPage, selectedType]);

  const handleOpen = async (id) => {
    setModalShow(true);
    if (id) {
      setUpdate(true);
      const response = await ColorCodeService.GetColorCode(id);
      const result = response.data.data;
      formik.setFieldValue("seasonName", result.seasonName);
      result.colorCodeDetail.forEach((address, index) => {
        setAddNumbers(result.colorCodeDetail.length);
        formik.setFieldValue(
          `colorCodeDetail[${index}].playerName`,
          address.playerName
        );
        formik.setFieldValue(
          `colorCodeDetail[${index}].textColorCode`,
          address.textColorCode
        );
        formik.setFieldValue(
          `colorCodeDetail[${index}].colorCode`,
          address.colorCode
        );
      });
    } else {
      formik.resetForm();
      setUpdate(false);
    }
  };

  const initialValue = {
    seasonName: "",
    colorCodeDetail: [
      {
        playerName: "",
        colorCode: "",
        textColorCode: "",
      },
    ],
  };

  const submit = async (values, action) => {
    try {
      setLoader(true);
      const data = { ...values, type: selectedType.toUpperCase() };
      await ColorCodeService.CreateColorCode(data);
      setLoader(false);
      setModalShow(false);
      getAllData();
      action.resetForm();
      formik.resetForm();
      setAddNumbers(1);
    } catch (error) {
      enqueueSnackbar("Something Wrong", {
        variant: "error",
      });
      setLoader(false);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  const addNumber = () => {
    formik.setFieldValue("colorCodeDetail", [
      ...formik.values.colorCodeDetail,
      {
        playerName: "",
        colorCode: "",
        textColorCode: "",
      },
    ]);
    setAddNumbers(addNumbers + 1);
  };

  const removeNumber = (index) => {
    if (addNumbers > 1) {
      formik.setFieldValue(
        "colorCodeDetail",
        formik.values.colorCodeDetail.filter((_, i) => i !== index)
      );
      setAddNumbers(addNumbers - 1);
    }
  };

  const handleChangeColor = (index, country) => {
    formik.setFieldValue(
      `colorCodeDetail[${index}].playerName`,
      country.target.value
    );
  };

  const handleChangeColorCode = (color) => {
    setColor(color.hex);
  };

  const handleTogglePicker = (index) => {
    const updatedColorPickerOpen = [...colorPickerOpen];
    updatedColorPickerOpen[index] = !updatedColorPickerOpen[index];
    setColorPickerOpen(updatedColorPickerOpen);
    setTempColor(color);
    setShowPicker(true);
  };
  const handleTextTogglePicker = (index) => {
    const updatedColorPickerOpen = [...colorPickerOpen2];
    updatedColorPickerOpen[index] = !updatedColorPickerOpen[index];
    setColorPickerOpen2(updatedColorPickerOpen);
    setTempColor2(color2);
    setShowPicker2(true);
  };

  const handleColorChange = (newColor, index) => {
    if (newColor.hex === undefined) {
      setTempColor(newColor.target.value);
    } else {
      setTempColor(newColor.hex);
    }
    formik.setFieldValue(`colorCodeDetail[${index}].colorCode`, tempColor);
  };

  const handleTextColorChange = (newColor, index) => {
    if (newColor.hex === undefined) {
      setTempColor2(newColor.target.value);
    } else {
      setTempColor2(newColor.hex);
    }
    formik.setFieldValue(`colorCodeDetail[${index}].textColorCode`, tempColor2);
  };

  const handleOk = (index) => {
    const updatedColorPickerOpen = [...colorPickerOpen];
    updatedColorPickerOpen[index] = !updatedColorPickerOpen[index];
    setColorPickerOpen(updatedColorPickerOpen);
    setColor(tempColor);
    setShowPicker(false);
  };

  const handleCancel = (index) => {
    const updatedColorPickerOpen = [...colorPickerOpen];
    updatedColorPickerOpen[index] = !updatedColorPickerOpen[index];
    setColorPickerOpen(updatedColorPickerOpen);
    setShowPicker(false);
    setTempColor(color);
  };

  const handleOk2 = (index) => {
    const updatedColorPickerOpen = [...colorPickerOpen2];
    updatedColorPickerOpen[index] = !updatedColorPickerOpen[index];
    setColorPickerOpen2(updatedColorPickerOpen);
    setColor2(tempColor);
    setShowPicker2(false);
  };

  const handleCancel2 = (index) => {
    const updatedColorPickerOpen = [...colorPickerOpen2];
    updatedColorPickerOpen[index] = !updatedColorPickerOpen[index];
    setColorPickerOpen2(updatedColorPickerOpen);
    setShowPicker2(false);
    setTempColor2(color);
  };

  return (
    <>
      <div className="page-header2"></div>
      <div className="row">
        <Col sm={12} md={6} lg={6} xl={3}>
          <Card className="custom-card">
            <Card.Body>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Total Color Code
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fas fa-palette icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalRows}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col sm={12} md={6} lg={6} xl={6} className="ms-auto mt-auto">
          <div
            className="custom-card text-end  pointer"
            style={{ marginRight: "18px" }}>
            <Button
              className="text-white"
              style={{ marginBottom: "5px", marginLeft: "15px" }}
              onClick={() => handleOpen("")}>
              <i className="fas fa-plus"></i> &nbsp; Add Color Code
            </Button>
            {modalShow && (
              <AddColorCode
                selectedType={selectedType}
                show={modalShow}
                onHide={handleDialogClose}
                formik={formik}
                loader={loader}
                addNumber={addNumber}
                addNumbers={addNumbers}
                removeNumber={removeNumber}
                handleChangeColor={handleChangeColor}
                handleChangeColorCode={handleChangeColorCode}
                handleTogglePicker={handleTogglePicker}
                tempColor={tempColor}
                handleColorChange={handleColorChange}
                showPicker={showPicker}
                handleOk={handleOk}
                handleOk2={handleOk2}
                handleCancel={handleCancel}
                colorPickerOpen={colorPickerOpen}
                color={color}
                color2={color2}
                handleTextColorChange={handleTextColorChange}
                handleTextTogglePicker={handleTextTogglePicker}
                colorPickerOpen2={colorPickerOpen2}
                showPicker2={showPicker2}
                handleCancel2={handleCancel2}
                setAddNumbers={setAddNumbers}
                update={update}
              />
            )}
            {deleteModal && (
              <DeleteColorCode
                show={deleteModal}
                onHide={handleDeleteClose}
                formik={formik}
                getAllStanding={getAllData}
              />
            )}
          </div>
        </Col>
      </div>

      <ColorCodeTable
        selectedType={selectedType}
        data={data}
        totalRows={totalRows}
        dataPerPage={dataPerPage}
        handlePerPageChange={handlePerPageChange}
        handlePageChange={handlePageChange}
        isLoading={isLoading}
        setDataPerPage={setDataPerPage}
        getAllStanding={getAllData}
        handleOpen={handleOpen}
      />
    </>
  );
}
